"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_modal_1 = (0, tslib_1.__importDefault)(require("react-modal"));
const Button_1 = (0, tslib_1.__importDefault)(require("../../atoms/Button"));
const S = (0, tslib_1.__importStar)(require("./styles"));
const PopUp = ({ isOpen = false, title = undefined, text = undefined, backgroundImage = undefined, ctaText = undefined, ctaURL = undefined, toggleModal = undefined, size = undefined, }) => {
    (0, react_1.useEffect)(() => {
        const { content } = S.customStyles;
        if (size === 'small' && content) {
            content.width = '20%';
        }
        else if (size === 'medium' && content) {
            content.width = '50%';
        }
        else if (size === 'large' && content) {
            content.width = '90%';
        }
        if (!!backgroundImage && content) {
            content.backgroundImage = `url(${backgroundImage})`;
            content.backgroundRepeat = 'no-repeat';
            content.backgroundSize = 'cover';
        }
    }, [size, backgroundImage]);
    const handleCTAClick = () => {
        window.open(ctaURL, '_blank');
    };
    return ((0, jsx_runtime_1.jsxs)(react_modal_1.default, Object.assign({ isOpen: isOpen, style: S.customStyles, ariaHideApp: false }, { children: [(0, jsx_runtime_1.jsx)(S.ButtonCloseModal, { onClick: toggleModal, title: "Close" }, void 0), (0, jsx_runtime_1.jsxs)(S.PopUpContainer, { children: [!!title ? (0, jsx_runtime_1.jsx)(S.PopUpTitle, { children: title }, void 0) : undefined, !!text ? (0, jsx_runtime_1.jsx)(S.PopUpText, { children: text }, void 0) : undefined, !!ctaText ? ((0, jsx_runtime_1.jsx)(S.PopUpCTA, { children: (0, jsx_runtime_1.jsx)(Button_1.default, { size: "medium", label: ctaText, onClick: !!ctaURL ? handleCTAClick : undefined, colorOption: 'blue' }, void 0) }, void 0)) : undefined] }, void 0)] }), void 0));
};
exports.default = PopUp;
